var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestorePeople = function SvgRestorePeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30859 16.5039C10.1625 15.8866 12.1668 15.887 14.0205 16.5049L16.3965 17.2969C17.3188 17.6044 17.9414 18.4672 17.9414 19.4395V21.1992H4.3877V19.4375C4.38773 18.465 5.01089 17.6022 5.93359 17.2949L8.30859 16.5039ZM11.1641 7.64648C13.0353 7.64648 14.5527 9.16389 14.5527 11.0352C14.5526 12.9063 13.0352 14.4229 11.1641 14.4229C9.29309 14.4226 7.7765 12.9062 7.77637 11.0352C7.77637 9.16404 9.29301 7.64674 11.1641 7.64648Z",
    fill: "#0F4AB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.378 12.1951C20.378 6.9821 16.1521 2.7561 10.939 2.7561C5.72599 2.7561 1.5 6.9821 1.5 12.1951",
    stroke: "#0F4AB8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2319 10.0976L20.3783 13.2439L23.0002 10.0976",
    stroke: "#0F4AB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRestorePeople;